import { useCallback } from 'react';

export const useExportTxt = () => {
    const exportToTxt = useCallback((data: string, filename: string = 'export.txt') => {
        const blob = new Blob([data], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, []);

    return { exportToTxt };
};